export type PrintSequenceMode = 'branch_continuous' | 'wrap_from_one' | 'manual_start'

export function parsePrintSequenceMode(raw: unknown): PrintSequenceMode {
  if (raw === 'wrap_from_one' || raw === 'manual_start') return raw
  return 'branch_continuous'
}

export function isPrintSequenceOptIn(mode: PrintSequenceMode): boolean {
  return mode === 'wrap_from_one' || mode === 'manual_start'
}

export function kitchenPrintSequenceMapKey(
  branchId: string,
  mode: PrintSequenceMode,
  ids: { registerId?: string | null; shiftId?: string | null },
): string {
  if (!isPrintSequenceOptIn(mode)) return branchId
  if (ids.registerId) return `${branchId}:register:${ids.registerId}`
  if (ids.shiftId) return `${branchId}:shift:${ids.shiftId}`
  return branchId
}

export function suggestedManualPrintSequenceStart(last: number | null | undefined, start: number | null | undefined, max: number | null): number {
  const chosenStart = start != null && start >= 1 ? start : 1
  if (last == null || last < 1) return chosenStart
  const next = last + 1
  if (max != null && next > max) return chosenStart
  return next
}
